import React, { useState } from 'react';
import API from '../api';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './login.css';
import './resetPassword.css';
import logo from '../assets/merchant-marvels.jpg';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');
  const userid = searchParams.get('userid');

  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const res = await API.post('/auth/reset-password', {
        token,
        userid,
        password,
      });
      setMessage(res.data.message || 'Password reset successful!');
      setTimeout(() => navigate('/login'), 1200);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mm-login-container">
      {/* Left hero shared */}
      <div className="mm-login-left">
        <div className="mm-welcome-message">
          <h1>Welcome To Merchant Marvels</h1>
          <p>Reset your password to continue accessing powerful insights.</p>
        </div>
      </div>

      {/* Right card */}
      <div className="mm-login-right">
        <div className="mm-login-logo-wrapper">
          <img
            src={logo}
            alt="Merchant Marvels"
            className="mm-login-logo"
          />
        </div>

        <div className="mm-login-form-wrapper">
          <form onSubmit={handleSubmit} className="mm-login-form">
            <h2 className="mm-login-title">Reset Password</h2>
            <p className="mm-login-subtitle">
              Enter your new password below.
            </p>

            <div className="mm-input-wrapper">
              <div className="mm-label">New Password</div>
              <input
                type="password"
                className="mm-login-input"
                value={password}
                placeholder="Enter New Password"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="mm-login-button" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>

            {message && <div className="rpw-success">{message}</div>}
            {error && <div className="rpw-error">{error}</div>}

            <p className="mm-login-footer">
              Back to{' '}
              <a href="/login" className="mm-link">
                Login
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
